'use strict';

var constants = require('../constants.cjs');
var flexHttpError = require('../models/flexHttpError.cjs');
var axiosError = require('./axiosError.cjs');
var customError = require('./customError.cjs');
var flexHttpError$1 = require('./flexHttpError.cjs');

function transformBlobToStringSynchronously(blob) {
  const url = URL.createObjectURL(blob);
  const xmlHttpRequest = new XMLHttpRequest();
  xmlHttpRequest.open("GET", url, false);
  xmlHttpRequest.send();
  URL.revokeObjectURL(url);
  return xmlHttpRequest.responseText;
}
function getHttpErrorData(data = {
  code: constants.UNKNOWN_ERROR
}) {
  if (globalThis.Blob && data instanceof globalThis.Blob) {
    const stringifiedData = transformBlobToStringSynchronously(data);
    try {
      return flexHttpError$1.toFlexHttpError(JSON.parse(stringifiedData));
    } catch {
      return new flexHttpError.FlexHttpError(
        constants.JSON_PARSING_FAILED_BLOB_ERROR,
        "Blob parsing failed",
        900
      );
    }
  }
  return flexHttpError$1.toFlexHttpError(data);
}
function decideError(error) {
  if (customError.isRouteChangeCanceledError(error)) {
    return [constants.CustomErrorType.RouteChangeCanceled, void 0];
  }
  if (customError.isAccessTokenTypeError(error)) {
    return [constants.CustomErrorType.AccessTokenTypeError, void 0];
  }
  if (!axiosError.isAxiosError(error)) {
    return [constants.CustomErrorType.Unknown, void 0];
  }
  const { response } = error;
  const { status = constants.UNKNOWN_ERROR, data = {} } = response ?? {};
  const { code, message, trace } = getHttpErrorData(data);
  const httpError = new flexHttpError.FlexHttpError(
    code,
    message,
    status,
    "decide-error",
    trace
  );
  if (status === 401 && code === constants.RESERVED_ERROR_CODE.UNAUTHORIZED_FFA) {
    return [constants.HttpErrorType.FfaUnauthorized, httpError];
  } else if (status === 401 && code === constants.RESERVED_ERROR_CODE.INVALID_ACCOUNT) {
    return [constants.HttpErrorType.InvalidAccount, httpError];
  } else if (status === 401) {
    return [constants.HttpErrorType.Unauthorized, httpError];
  } else if (status === 403 && code === constants.RESERVED_ERROR_CODE.IP_ALL_FEATURES) {
    return [constants.HttpErrorType.IpBlockedAllFeature, httpError];
  } else if (status === 403 && code === constants.RESERVED_ERROR_CODE.IP_SPECIFIC_FEATURE) {
    return [constants.HttpErrorType.IpBlockedRoles, httpError];
  } else if (status === 403 && (code === constants.RESERVED_ERROR_CODE.FORBIDDEN || code === constants.RESERVED_ERROR_CODE.FORBIDDEN_LEGACY)) {
    return [constants.HttpErrorType.Forbidden, httpError];
  } else if (status >= 500 && status < 600) {
    return [constants.CustomErrorType.ServerError, httpError];
  }
  return [constants.CustomErrorType.Unknown, httpError];
}

exports.decideError = decideError;
//# sourceMappingURL=apiError.cjs.map
